export default __webpack_public_path__ + "static/media/576.f718dd35.png";